import type { enPolish } from './en-polish';

/** Turkish strings — polish round 1: pause → main menu. */
export const trPolish: Record<keyof typeof enPolish, string> = {
  'pause.home': 'ANA MENÜ',
  'pause.homeSaved': 'Run kaydedildi — DEVAM ET tam buradan sürdürür.',
  'pause.homeRewind': 'Bu dövüş kaybolur — DEVAM ET son kayda döner.',
  'pause.homeLost': 'Henüz kayıt yok — bu run biter.',
} as const;
